import CustomerNameItem from '../../components/CustomerNameItem.vue'
import StoreItem from '../../components/StoreItem.vue'
import { validatorPayDay, validatorPresentDays } from './rules'

export default function config() {
  // 选择客户基础信息
  const c_baseInfoList = [
    {
      el: 'select',
      itemConfig: {
        label: '选择门店',
        prop: 'storeId',
        value: '',
      },
      elConfig: {
        options: {
          label: 'name',
          value: 'id',
        },
        loading: false,
      },
      elRender: StoreItem,
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '个人客户',
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        ref: 'customerNameItem',
      },
      elConfig: {
        options: {
          label: 'customerName',
          value: 'id',
        },
        remoteMethod: this.customerNameRemoteMethod,
        events: {
          change: this.customerNameChange,
          tipsClick: this.tipsClick,
        },
        disabled: false,
        placeholder: '请输入',
      },
      elRender: CustomerNameItem,
    },
  ]
  const c_baseInfoModel = {}
  const c_baseInfoRules = {
    storeId: [
      { required: true, message: '请选择门店', trigger: 'change' },
    ],
    customerName: [
      { required: true, message: '请选择客户', trigger: 'change' },
    ],
  }

  // 客户信息
  const c_customerInfoList = [
    {
      el: 'text',
      itemConfig: {
        label: '客户ID',
        prop: 'customerId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '身份证号',
        prop: 'idCardNo',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '身份证有效期',
        prop: 'idCardValidDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '驾照有效期',
        prop: 'driverLicenceValidDate',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '人证有效期',
        prop: 'hailingLicenceValidDate',
      },
    },
  ]
  const c_customerInfoModel = {}

  // 租赁方案选择
  const c_leaseSchemeList = [
    {
      el: 'select',
      itemConfig: {
        label: '选择租赁方案',
        prop: 'planId',
        value: 0,
      },
      elConfig: {
        options: {
          label: 'name',
          value: 'id',
          list: [{ id: 0, name: '自定义' }],
        },
        events: {
          change: (val) => {
            this.c_vehicleSelectionModel.plateNo = ''
            this.planChange(val)
          },
        },
      },
    },
  ]
  const c_leaseSchemeModel = {
    planId: 0,
  }
  const c_leaseSchemeRules = {
    planId: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
  }
  const c_vehicleModelModel = {
    modelId: '',
  }

  // 阶梯配置 默认两个阶梯
  const ladderSchemeConfig = {
    isOpen: 0,
    unit: 1,
    clickNumber: 0, // 点击匹配租金次数
    ladderSchemeConfig: false, // 置灰
    ladderSchemeList: [
      {
        startMonth: 1, // 开始时间为1
        endMonth: '',
        amount: '',
      },
      {
        startMonth: '',
        endMonth: '',
        amount: '',
      },
    ],
  }

  // 租赁设置顶部预览
  const c_leaseSetupTopPreviewList = [
    {
      el: 'text',
      itemConfig: {
        label: '所属门店',
        prop: 'storeName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '司机姓名',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '身份证号',
        prop: 'idCardNo',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '联系电话',
        prop: 'customerTel',
      },
    },
  ]

  // 支付计划校验
  const m_rules = {
    presentDays: [
      { validator: validatorPresentDays.bind(this), trigger: 'change' },
    ],
    payDay: [
      { validator: validatorPayDay, trigger: 'change' },
    ],
  }

  // 支付计划底部统计默认展示列表
  const m_bottomTotalDefaultList = [
    {
      code: 1,
      number: 0,
    },
    {
      code: 2,
      number: 0,
    },
    {
      code: 3,
      number: 0,
    },
    {
      code: 4,
      number: 0,
    },
  ]
  // 周付 缴款日下拉列表
  const m_weekList = [
    {
      code: 1,
      name: '每周一',
    },
    {
      code: 2,
      name: '每周二',
    },
    {
      code: 3,
      name: '每周三',
    },
    {
      code: 4,
      name: '每周四',
    },
    {
      code: 5,
      name: '每周五',
    },
    {
      code: 6,
      name: '每周六',
    },
    {
      code: 7,
      name: '每周日',
    },
  ]
  // 日期配置
  const pickerOptions = {
    pickerOptions: {
      shortcuts: [
        {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          },
        },
      ],
    },
  }

  // 绑定车辆顶部预览
  const c_vehicleSelectionTopPreviewList = [
    {
      el: 'text',
      itemConfig: {
        label: '所属门店',
        prop: 'storeName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
        value: '个人客户',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁方案',
        prop: 'planName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '订车车型',
        prop: 'modelName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁类型',
        prop: 'categoryName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '收款起止日期',
        prop: 'startStopDate',
      },
    },
  ]

  // 车辆选择
  const c_vehicleSelectionList = [
    {
      el: 'select',
      itemConfig: {
        label: '是否备车',
        prop: 'readyLeaseState',
      },
      elConfig: {
        options: {
          label: 'readyLeaseState',
          value: 'id',
          list: [{
            id: '',
            readyLeaseState: '全部',
          },
          {
            id: 1,
            readyLeaseState: '已备车',
          }],
        },
        events: {
          change: this.readyLeaseStateChange,
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '绑定车辆',
        prop: 'plateNo',
      },
      elConfig: {
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
        events: {
          change: this.plateNoChange,
        },
      },
    },
  ]
  const c_vehicleSelectionModel = {
    readyLeaseState: '',
    plateNo: '',
  }
  const c_vehicleSelectionRules = {
    plateNo: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
  }
  // 车辆信息
  const c_vehicleInfoList = [
    {
      el: 'text',
      itemConfig: {
        label: '车辆ID',
        prop: 'carId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆状态',
        prop: 'carStateName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆库存状态',
        prop: 'inventoryStateName',
      },
    },
  ]
  const c_vehicleInfomodel = {
    carId: '',
    carStateName: '',
    inventoryStateName: '',
  }

  return {
    // 车辆信息
    c_vehicleInfoList,
    c_vehicleInfomodel,
    // 车辆选择
    c_vehicleSelectionList,
    c_vehicleSelectionModel,
    c_vehicleSelectionRules,
    // 绑定车辆顶部预览
    c_vehicleSelectionTopPreviewList,
    // 租赁设置顶部预览
    c_leaseSetupTopPreviewList,
    // 日期配置
    pickerOptions,
    // 支付计划底部统计默认展示列表
    m_bottomTotalDefaultList,
    // 周付 缴款日下拉列表
    m_weekList,
    // 支付计划校验
    m_rules,
    // 阶梯配置
    ladderSchemeConfig,
    // 车型选择
    c_vehicleModelModel,
    // 租赁方案选择
    c_leaseSchemeList,
    c_leaseSchemeModel,
    c_leaseSchemeRules,
    // 客户信息
    c_customerInfoList,
    c_customerInfoModel,
    // 选择客户
    c_baseInfoList,
    c_baseInfoModel,
    c_baseInfoRules,
  }
}
